(function() {
    // Get 'OR' sections that divide up the page
    var dividers = document.getElementsByClassName("divider");
    // Remove the final 'OR' divider
    dividers[dividers.length-1].remove();

    // Get divs used to create an account
    var createDivs = document.getElementsByClassName("create");
    // Remove them from the page
    for (var i = createDivs.length - 1; i >= 0; i--) {
          createDivs[0].parentNode.removeChild(createDivs[0]);
    }

    // Remove headings
    document.querySelectorAll("h2").forEach(e => e.remove());

    // Place social sign in after local account
    document.querySelector("#localAccountForm").insertAdjacentElement("afterend", document.querySelectorAll(".social")[0])
})();